import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../components/ui/dialog';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// StylesTab — admin CRUD for predefined decoration styles
const StylesTab = () => {
  const [styles, setStyles] = useState([]);
  const [showStyleDialog, setShowStyleDialog] = useState(false);
  const [styleForm, setStyleForm] = useState({ name: '', description: '' });

  const load = async () => {
    try {
      const r = await axios.get(`${API}/user/styles`, { withCredentials: true });
      setStyles(r.data);
    } catch {
      toast.error('Erreur de chargement');
    }
  };
  useEffect(() => { load(); }, []);

  const handleCreateStyle = async () => {
    try {
      await axios.post(`${API}/admin/styles?name=${encodeURIComponent(styleForm.name)}&description=${encodeURIComponent(styleForm.description)}`, {}, { withCredentials: true });
      toast.success('Style créé');
      load();
      setShowStyleDialog(false);
      setStyleForm({ name: '', description: '' });
    } catch {
      toast.error('Erreur');
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-medium">Styles de décoration</h2>
        <Button onClick={() => setShowStyleDialog(true)}>
          <Plus className="w-4 h-4 mr-2" />
          Nouveau style
        </Button>
      </div>
      <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
        {styles.filter(s => s.is_predefined).map(style => (
          <div key={style.style_id} className="bg-white rounded-xl border border-gray-200 p-4">
            <h3 className="font-medium text-gray-900">{style.name}</h3>
            <p className="text-sm text-gray-500 mt-1">{style.description}</p>
          </div>
        ))}
      </div>

      <Dialog open={showStyleDialog} onOpenChange={setShowStyleDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Nouveau style</DialogTitle></DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-2">Nom *</label>
              <Input value={styleForm.name} onChange={(e) => setStyleForm({ ...styleForm, name: e.target.value })} placeholder="Ex: Art Déco" />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-2">Description</label>
              <Input value={styleForm.description} onChange={(e) => setStyleForm({ ...styleForm, description: e.target.value })} placeholder="Description du style" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowStyleDialog(false)}>Annuler</Button>
            <Button onClick={handleCreateStyle} className="bg-blue-600 hover:bg-blue-700">Créer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default StylesTab;
